function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "110",
  height: "100"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a4beb2ac-b902-4eaf-913c-f90275d4c103",
  "data-name": "New Gradient Swatch 5",
  x1: "5.59",
  y1: "-4.41",
  x2: "73",
  y2: "63",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a65bef58-523d-4ab2-aa2b-abf844054b7f",
  x1: "36.26",
  y1: "26.26",
  x2: "112.18",
  y2: "102.18",
  xlinkHref: "#a4beb2ac-b902-4eaf-913c-f90275d4c103"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eba387c6-5590-472f-81ec-2b3238bf0d4d",
  x1: "36.44",
  y1: "26.44",
  x2: "112.01",
  y2: "102.01",
  xlinkHref: "#a4beb2ac-b902-4eaf-913c-f90275d4c103"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a0451b37-e70d-4850-8a8f-9df7d5d85a79",
  x1: "81.5",
  y1: "51",
  x2: "95.5",
  y2: "51",
  xlinkHref: "#a4beb2ac-b902-4eaf-913c-f90275d4c103"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "b87bf8ce-7d02-49ee-8378-f2e30aa6c017",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98 0H2a2 2 0 00-2 2v76a2 2 0 002 2h42v-4h-7a1 1 0 01-1-1v-6a1 1 0 011-1h7V36h56V2a2 2 0 00-2-2zM68 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H69a1 1 0 01-1-1zM52 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H53a1 1 0 01-1-1zM36 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H37a1 1 0 01-1-1zM20 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H21a1 1 0 01-1-1zM4 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1zm12 70a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H21a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm64-64a1 1 0 01-1 1H85a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1z",
  fill: "url(#a4beb2ac-b902-4eaf-913c-f90275d4c103)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 17v19H44v28H5a1 1 0 01-1-1V17a1 1 0 011-1h90a1 1 0 011 1z",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 41.83V64H5a1 1 0 01-1-1V50.76C15.34 42 24.72 40.13 31.06 40A41.06 41.06 0 0144 41.83z",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: "50",
  y: "40",
  width: "52",
  height: "52",
  rx: "2",
  fill: "url(#a65bef58-523d-4ab2-aa2b-abf844054b7f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 34v64a2 2 0 002 2h64a2 2 0 002-2V34a2 2 0 00-2-2H44a2 2 0 00-2 2zm61.81 62H48.19A2.19 2.19 0 0146 93.81V38.19A2.19 2.19 0 0148.19 36h55.62a2.19 2.19 0 012.19 2.19v55.62a2.19 2.19 0 01-2.19 2.19z",
  fill: "url(#eba387c6-5590-472f-81ec-2b3238bf0d4d)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "88.5",
  cy: "51",
  r: "7",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".2",
  fill: "url(#a0451b37-e70d-4850-8a8f-9df7d5d85a79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102 53.62L85 81 67.25 65.07 50 82.62V90a2 2 0 002 2h48a2 2 0 002-2z",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2",
  d: "M67.44 65.06l29.12 26.93h-21l-8.12-26.93z"
})))));